module.exports = __webpack_public_path__ + "static/media/dutch_image_presentation.a76ab29f.png";